export default "__VITE_ASSET__Bc9Wcapt__"